import React from "react";
import IncrementCounter from "../../common/IncrementCounter";

function Achievement() {
  const achievements = [
    {
      key: "patients",
      title: "Total patients",
      value: 60,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/achievement/patient.png",
      imgAlt: "patient",
      incrementPerYear: 18,
    },
    {
      key: "camps",
      title: "Camps",
      value: 800,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/achievement/doctor.png",
      imgAlt: "doctor",
      incrementPerYear: 50,
    },
    {
      key: "surgeries",
      title: "Surgeries",
      value: 10,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/achievement/surgery.png",
      imgAlt: "surgery",
      incrementPerYear: 2,
    },
    {
      key: "experience",
      title: "Years Experience",
      value: 15,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/achievement/experience.png",
      imgAlt: "experience",
      incrementPerYear: 1,
    },
  ];
  return (
    <section className="ttm-row broken-section f clearfix">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-lg-12 col-md-12">
            <div className="ttm-bg ttm-bgcolor-skincolor ttm-left-span spacing-5">
              <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                <div className="ttm-col-wrapper-bg-layer-inner"></div>
              </div>
              <div className="layer-content">
                <div className="row ttm-vertical_sep">
                  {achievements.map((item) => (
                    <div className="col-lg-3 col-md-6 col-sm-6 ttm-box-col-wrapper">
                      <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style1">
                        <div className="ttm-fid-icon-wrapper">
                          <img
                            src={item.img}
                            alt={item.imgAlt}
                            style={{
                              color: "#12b48b",
                              width: "50px",
                              height: "50px",
                            }}
                          />
                        </div>
                        <div className="ttm-fid-contents">
                          <h4 className="ttm-fid-inner">
                            {
                              <IncrementCounter
                                intialCount={item.value}
                                startYear={2025}
                                incrementPerYear={item.incrementPerYear}
                                classes="numinate completed achievement-incrementor"
                              />
                            }
                            <span classes="achievement-incrementor">
                              {item.key === "patients" ||
                              item.key === "surgeries"
                                ? "k"
                                : ""}
                              +
                            </span>
                          </h4>
                          <h3
                            className="ttm-fid-title"
                            style={{ color: "#fff" }}
                          >
                            {item.title.toUpperCase()}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Achievement;
